import { enqueueSnackbar } from 'notistack';

import { challengeSignUpStore } from '../../../../../../../stores/challengeSignUpStore';
import {
  CHALLENGE_PAYMENT_RESULT_TYPE,
  challengePaymentService,
  checkoutService,
  pathQueryParams,
} from '../../../../../../../../payment';
import { DivisionFormValues, unknownDivisionId } from '../ChooseChallengeStep.settings';
import { challengeSignUpService } from '../../../../../../../services/challengeSignUpService';
import { getCurrentUrl, goTo } from '../../../../../../../../shared/utils/angularUtils';

type UseChallengeSubscriptionReturn = {
  handleApplyPromoCode: (promoCode: string) => void;
  handleSubscribeToChallenge: (divisionFormValues: DivisionFormValues) => Promise<void>;
};

//consumer component should be mobX observer
const useChallengeSubscription = (): UseChallengeSubscriptionReturn => {
  const {
    participantId,
    challengePaymentInfo,
    setChallengePaymentInfo,
    setAppliedPromoCode,
  } = challengeSignUpStore;

  const handleApplyPromoCode = async (promoCode: string) => {
    if (!participantId) {
      throw new Error('Participant ID is not defined');
    }

    const challengeInfo = await challengePaymentService.applyPromoCode(
      participantId,
      promoCode,
    );

    setChallengePaymentInfo(challengeInfo.challengeSetup);
    setAppliedPromoCode(challengeInfo.promocode);

    enqueueSnackbar('Promo code successfully applied', {
      variant: 'success',
      autoHideDuration: 3000,
    });
  };

  const withoutPayment = challengePaymentInfo?.priceFinal === 0;

  const handleSubscribeToChallenge = async (formValues: DivisionFormValues) => {
    if (!participantId) {
      throw new Error('Participant ID is not defined');
    }

    const { divisionId } = formValues;

    if (divisionId && divisionId !== unknownDivisionId) {
      await challengeSignUpService.setDivision(participantId, divisionId);
    }

    const currentUrl = getCurrentUrl();

    if (withoutPayment) {
      const { challengeParticipantId } =
        await checkoutService.createFreeChallengeSubscription(participantId);
      goTo('/challenge-payment-result', {
        replaceHistory: true,
        params: {
          [pathQueryParams.participantId]: challengeParticipantId,
          [pathQueryParams.retryPath]: currentUrl,
          [pathQueryParams.paymentResultType]: CHALLENGE_PAYMENT_RESULT_TYPE.FREE,
          [pathQueryParams.redirectStatus]: 'succeeded',
        },
      });
    } else {
      goTo('/challenge-checkout', {
        replaceHistory: true,
        params: {
          [pathQueryParams.participantId]: participantId,
          [pathQueryParams.retryPath]: currentUrl,
        },
      });
    }
  };

  return {
    handleSubscribeToChallenge,
    handleApplyPromoCode,
  };
};

export { useChallengeSubscription };
